import { FC } from "react";
import { Icon, InformationItem, Modal } from "../../common";
import { CreateInvoiceAction } from "../../actions";

type Props = {
  isOpen: boolean;
  close: () => void;
};

export const KycSuccessModal: FC<Props> = ({ isOpen, close }) => (
  <Modal isOpen={isOpen} close={close}>
    <div className="flex flex-col items-stretch gap-8">
      <div className="flex flex-col items-center gap-4">
        <Icon
          icon="check_circle_outline"
          size={64}
          className="text-green-500"
        />

        <div className="font-poppins font-bold text-xl">
          Your profile has been verified
        </div>

        <div className="font-medium text-gray-300">
          You're all set to do business
        </div>
      </div>

      <div className="flex flex-col gap-6 grow">
        <InformationItem
          icon="File"
          title="Issue invoices"
          description="Up to 30 invoices per month"
        />

        <InformationItem
          icon="Payments"
          title="Receive payments"
          description="Up EUR 15 000 per month"
        />
      </div>

      <div className="flex justify-center mt-4">
        <CreateInvoiceAction>Create first invoice</CreateInvoiceAction>
      </div>
    </div>
  </Modal>
);
